<script>
    import Item from "../components/Item/index.svelte";
    export let editionUID;
    let items = [];

    function getSubscriptionEdition() {
        fetch(`/api/v1/subscription-edition/${editionUID}`)
        .then(data => data.json())
        .then(response => {
            ({ items } = response);
        });
    }

    getSubscriptionEdition()
</script>

<main>

    {#if items}
        {#each items as item, index (index)}
            <Item index={index} item={item} />
        {/each}
    {/if}

</main>

<style>
    main {
        max-width: 600px;
        margin: auto;
    }
</style>